import { createContext } from 'react';

export interface ElevationValue {
  /** Until when the session is elevated, or null. */
  elevatedUntil: Date | null;
  /** Resolve once the session is elevated; reject when the person cancels. */
  ensureElevated: () => Promise<void>;
  /**
   * Run `action`; if the API answers 403 `elevation_required`, ask for the password
   * and run it again once. Every guarded mutation of the panel goes through here, so a
   * person never sees a bare 403: they see the password prompt and then the result.
   */
  withElevation: <T>(action: () => Promise<T>) => Promise<T>;
}

export const ElevationContext = createContext<ElevationValue | null>(null);
